module.exports = __webpack_public_path__ + "media/customizations/trilith/logo-cdf15d1bec6352410b1cd20471174f46.png";